import { Expose } from 'class-transformer';
import { GlobalStrikeStatusEnum } from './global-strike-status.enum';

export class UserBookingBlockingDto {
  @Expose({ name: 'id' })
  id: number;
  @Expose({ name: 'user_id' })
  userId: number;
  @Expose({ name: 'status' })
  status: GlobalStrikeStatusEnum;
  @Expose({ name: 'blocking_date' })
  blockingDate: Date;
  @Expose({ name: 'blocking_expiration_date' })
  blockingExpirationDate: Date;
}
